import { DataAccessSearchHistoryItem } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityDataAccessSearchHistoryRequest = {
	count?: number;
};

export type GetDataSecurityDataAccessSearchHistoryResponse = Array<DataAccessSearchHistoryItem>;

export const getDataSecurityDataAccessSearchHistory =
	createGetEndpoint<GetDataSecurityDataAccessSearchHistoryRequest, GetDataSecurityDataAccessSearchHistoryResponse>(
		(request) => `/api/v3/salesforce/data-access/search-history?${getQueryString(request)}`
	);
